import React, { useEffect, useRef, useState } from 'react';

type Props = {
	children: React.ReactNode;
	rotulo?: string;
};

export default function CampoObservacao({ children, rotulo = 'Observações' }: Props) {
	const ref = useRef<HTMLDivElement>(null);
	const [aberto, setAberto] = useState(false);

	useEffect(() => {
		const campo = ref.current?.querySelector('textarea, input');
		const texto = campo && 'value' in campo ? String((campo as HTMLInputElement).value ?? '') : '';
		if (texto.trim()) {
			setAberto(true);
		}
	}, []);

	return (
		<div ref={ref}>
			<button
				type="button"
				className="btn btn-link p-0 mb-1"
				onClick={() => setAberto((atual) => !atual)}
			>
				{aberto ? `Recolher ${rotulo.toLowerCase()}` : rotulo}
			</button>
			<div style={{ display: aberto ? 'block' : 'none' }}>
				{children}
			</div>
		</div>
	);
}
